import { render, staticRenderFns } from "./privacyDetails.vue?vue&type=template&id=0f0a3d99&scoped=true&"
import script from "./privacyDetails.vue?vue&type=script&lang=js&"
export * from "./privacyDetails.vue?vue&type=script&lang=js&"
import style0 from "./privacyDetails.vue?vue&type=style&index=0&id=0f0a3d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a3d99",
  null
  
)

export default component.exports